exports = module.exports = require("../../node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-tab[data-v-2288192d]{font-size:20px}.counter[data-v-2288192d]{top:20px;right:5px}.nav-link-mobile.active[data-v-2288192d]{border-left:3px solid #1161bc;border-bottom:1px #e5e5e5!important}.nav-link-mobile[data-v-2288192d]{border-left:3px solid transparent;border-bottom:1px #e5e5e5!important}.nav-tabs[data-v-2288192d]{overflow-y:hidden}.animation-height[data-v-2288192d]{transition:all;transition-duration:.5s}.max-height[data-v-2288192d]{max-height:54px}.no-max-height[data-v-2288192d]{max-height:500px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader?minimize!./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2288192d","scoped":true,"hasInlineConfig":false}!./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/tabs.vue
// module id = 1210
// module chunks = 0